@if (!loading && !onboarding.loading$()) {
  @if(appAuthService.loggedIn$() && onboarding.hasIncomplete$() && !appAuthService.isAdmin) {
    <app-my-onboarding-progress [progress]="onboarding.progress$()"></app-my-onboarding-progress>
  }
  @else {
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  }
}
